import { PARTNER } from "@tm/isomorphic-utils";
import { deviceType } from "@tm/static/utils";
import styled from "styled-components";
import { InnerContentWrap } from "../../CommonStyle/CommonStyles.style";
import { FlexCompStyle } from "../FlexComp/FlexComp.style";
import { H2TagStyle, H4TagStyle } from "../TextStyles/TextStyles.style";

export const WhatsCoveredStyle = styled.section`
  background: #fff;
  width: 100%;
  ${H2TagStyle} {
    font-weight: 900;
  }
  ${(p) =>
    p.theme.pageTheme === PARTNER.MMT &&
    `
    ${H4TagStyle}{
        font-size:24px;
        font-weight:900;
    }
    `}
  @media ${deviceType.mobile} {
    padding: 0 16px;
    ${InnerContentWrap} {
      > ${FlexCompStyle} {
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        margin-right: -16px;
        margin-left: -16px;
        padding-left: 16px;
        padding-right: 16px;
      }
    }
  }
`;
export const BenefitItem = styled.div`
  flex: 1;
  @media ${deviceType.mobile} {
    width: 230px;
    flex-shrink: 0;
    flex: none;
  }
`;
